import { useEffect, useRef } from 'react'
import { useDDPInspectorContext } from './DDPInspectorContext'

// React 16.14 doesn't ship `useId`; this codebase is pinned there.
function useStableInspectorId () {
  const ref = useRef(null)
  if (ref.current === null) {
    ref.current = `ddp-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
  }
  return ref.current
}

export default function useRegisterDDPForInspector ({
  pipeline,
  variables,
  displayName,
  isLoading,
  error
}) {
  const { isActive, register, unregister } = useDDPInspectorContext()
  const id = useStableInspectorId()
  const isRegistered = isActive && !!pipeline

  useEffect(() => {
    if (!isActive) return
    if (!pipeline) {
      unregister(id)
      return
    }
    register(id, {
      displayName: displayName || (typeof pipeline === 'string' ? pipeline : 'inline pipeline'),
      pipeline,
      variables,
      status: isLoading ? 'loading' : (error ? 'error' : 'success'),
      error: error || null
    })
  }, [isActive, register, unregister, id, pipeline, variables, displayName, isLoading, error])

  useEffect(() => {
    if (!isActive) return undefined
    return () => unregister(id)
  }, [isActive, unregister, id])

  return isRegistered ? id : null
}
